import { Link } from "react-router-dom";
import { Mail, Instagram, MessageCircle } from "lucide-react";
import { CONTACT } from "@/lib/site";
import { useT } from "@/lib/i18n";
import LanguageSwitcher from "./LanguageSwitcher";

const Footer = () => {
  const t = useT();
  return (
    <footer data-testid="site-footer" className="bg-charcoal text-ivory mt-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-serif text-3xl italic">
              {t("brand.first")} <span className="text-terracotta not-italic font-medium">TAO</span>
            </div>
            <p className="mt-5 text-ivory/70 max-w-md leading-relaxed text-[15px]">
              {t("footer.tagline")}
            </p>
            <p className="mt-6 text-xs tracking-[0.25em] uppercase text-ivory/50">
              {t("footer.philosophyTag")}
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs tracking-[0.25em] uppercase text-ivory/50 mb-5">{t("footer.navigation")}</h4>
            <ul className="space-y-3 text-[14px]">
              <li><Link to="/sesion-gratuita" className="text-terracotta hover:text-ivory transition-colors">{t("nav.freeSession")}</Link></li>
              <li><Link to="/metodo-tao" className="text-ivory/85 hover:text-terracotta transition-colors">{t("nav.method")}</Link></li>
              <li><Link to="/mi-historia" className="text-ivory/85 hover:text-terracotta transition-colors">{t("nav.story")}</Link></li>
              <li><Link to="/oncologia" className="text-ivory/85 hover:text-terracotta transition-colors">{t("nav.oncology")}</Link></li>
              <li><Link to="/fibromialgia" className="text-ivory/85 hover:text-terracotta transition-colors">{t("nav.fibromyalgia")}</Link></li>
              <li><Link to="/sesiones-online" className="text-ivory/85 hover:text-terracotta transition-colors">{t("nav.online")}</Link></li>
              <li><Link to="/testimonios" className="text-ivory/85 hover:text-terracotta transition-colors">{t("nav.testimonials")}</Link></li>
              <li><Link to="/blog" className="text-ivory/85 hover:text-terracotta transition-colors">{t("nav.blog")}</Link></li>
              <li><Link to="/preguntas-frecuentes" className="text-ivory/85 hover:text-terracotta transition-colors">{t("footer.faq")}</Link></li>
              <li><Link to="/prensa" className="text-ivory/85 hover:text-terracotta transition-colors">{t("nav.press")}</Link></li>
              <li><Link to="/profesionales" className="text-ivory/85 hover:text-terracotta transition-colors">{t("footer.professionals")}</Link></li>
              <li><Link to="/asociaciones" className="text-ivory/85 hover:text-terracotta transition-colors">{t("footer.associations")}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs tracking-[0.25em] uppercase text-ivory/50 mb-5">{t("footer.contact")}</h4>
            <ul className="space-y-4 text-[14px]">
              <li>
                <a
                  href={CONTACT.whatsappUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  className="inline-flex items-center gap-3 text-ivory/85 hover:text-terracotta transition-colors"
                >
                  <MessageCircle size={16} /> WhatsApp · {CONTACT.whatsappDisplay}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="footer-email"
                  className="inline-flex items-center gap-3 text-ivory/85 hover:text-terracotta transition-colors break-all"
                >
                  <Mail size={16} /> {CONTACT.email}
                </a>
              </li>
              <li>
                <a
                  href={CONTACT.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram"
                  className="inline-flex items-center gap-3 text-ivory/85 hover:text-terracotta transition-colors"
                >
                  <Instagram size={16} /> @{CONTACT.instagram}
                </a>
              </li>
            </ul>
            <div className="mt-8">
              <Link
                to="/contacto"
                data-testid="footer-cta"
                className="inline-flex items-center bg-terracotta text-charcoal rounded-full px-6 py-3 text-[13px] font-medium hover:bg-ivory transition-colors"
              >
                {t("footer.ctaButton")}
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-ivory/10 flex flex-col md:flex-row gap-4 md:items-center md:justify-between text-xs text-ivory/45">
          <span>© {new Date().getFullYear()} Marta Montardit · {t("brand.first")} TAO. {t("footer.rights")}.</span>
          <LanguageSwitcher variant="footer" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
